export const messages = {
  en: {
    businessCenter: {
      search: 'Search',
      user: 'User',
      goods: 'Goods',
      order: 'Order',
      refundOrder: 'Refund Order',
      groupGoods: 'Group Goods',
      groupOrder: 'Group Order',
      seckillGoods: 'Seckill Goods',
      seckillOrder: 'Seckill Order',
      housekeepingService: 'Housekeeping Service',
      housekeepingResource: 'Housekeeping Resource'
    },
    businessDetailUser: {
      userId: 'User ID',
      userName: 'User Name',
      email: 'Email',
      address: 'Address',
      phone: 'Phone',
      registerTime: 'Register Time',
      operation: 'Operation',
      detail: 'Detail'
    }
  },
  zh: {
    businessCenter: {
      search: '查询',
      user: '会员',
      goods: '商品',
      order: '订单',
      refundOrder: '退货订单',
      groupGoods: '拼团商品',
      groupOrder: '拼团订单',
      seckillGoods: '秒杀商品',
      seckillOrder: '秒杀订单',
      housekeepingService: '家政服务',
      housekeepingResource: '家政物品'
    },
    businessDetailUser: {
      userId: '用户编号',
      userName: '用户名称',
      email: '邮箱',
      address: '地址',
      phone: '手机号',
      registerTime: '注册时间',
      operation: '操作',
      detail: '详情'
    }
  }
}